<template>
  <b-card
    title="مدیریت کالاها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                @click="addProduct()"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="کشور"
                  label-for="CountryId"
                >
                  <z-country
                    v-model="filterOptions.CountryId"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="برند"
                  label-for="BrandId"
                >
                  <z-brand
                    v-model="filterOptions.BrandId"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="updateProduct(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Brand)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(Country)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(PurchaseType)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(ProductUnit)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link @click="updateProduct(data.item)">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
      v-if="showProductModal"
      v-model="showProductModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="جزئیات کالا"
      :no-close-on-backdrop="true"
      size="lg"
      @ok="save"
    >
      <b-row>
        <b-col md="6">
          <b-form-group
            label="عنوان"
            label-for="Title"
          >
            <b-form-input
              v-model="row.Title"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            label="کد"
            label-for="Code"
          >
            <b-form-input
              v-model="row.Code"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            label="ارزش"
            label-for="DeclaredValue"
          >
            <b-form-input
              v-model="row.DeclaredValue"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            label="تعرفه"
            label-for="ProductTariffId"
          >
            <z-product-tariff v-model="row.ProductTariffId" />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            label="برند"
            label-for="BrandId"
          >
            <z-brand v-model="row.BrandId" />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            label="کشور"
            label-for="CountryId"
          >
            <z-country v-model="row.CountryId" />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            label="واحد"
            label-for="ProductUnitId"
          >
            <z-product-unit v-model="row.ProductUnitId" />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            label="اینکوترمز"
            label-for="PurchaseTypeId"
          >
            <z-purchase-type v-model="row.PurchaseTypeId" />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            label="وضعیت"
            label-for="IsActive"
          >
            <v-select
              v-model="row.IsActive"
              :options="enums('IsActive')"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="توضیحات"
            label-for="Description"
          >
            <b-form-textarea
              v-model="row.Description"
              rows="3"
              no-resize
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>

import ZCountry from '@/tools/country.vue'
import ZBrand from '@/tools/brand.vue'
import ZProductUnit from '@/tools/productunit.vue'
import ZPurchaseType from '@/tools/purchasetype.vue'
import ZProductTariff from '@/tools/producttariff.vue'

export default {
  name: 'Product',
  components: {
    ZProductTariff, ZPurchaseType, ZProductUnit, ZCountry, ZBrand,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        PerPage: 10,
        BrandId: null,
        CountryId: null,
      },
      showProductModal: false,
      row: {},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Code',
          label: 'کد',
        },
        {
          key: 'Brand',
          label: 'برند',
        },
        {
          key: 'Country',
          label: 'کشور',
        },
        {
          key: 'ProductUnit',
          label: 'واحد',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  computed: {},
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.product.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      let url = this.$api.product.add
      if (this.row.Id) {
        url = this.$api.product.update
      }

      this.$http.post(
        url, this.row,
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
          this.showProductModal = true
        })
    },
    addProduct() {
      this.row = {
        Title: null, Description: null, IsActive: true, PurchaseTypeId: null, ProductUnitId: null, BrandId: null, ProductTariffId: null, DeclaredValue: null
      }
      this.showProductModal = true
    },
    updateProduct(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.row.CountryId = this.row.Country.Id
      this.row.BrandId = this.row.Brand.Id
      this.row.ProductUnitId = this.row.ProductUnit.Id
      this.row.ProductTariffId = this.row.ProductTariff.Id
      this.row.PurchaseTypeId = this.row.PurchaseType.Id
      this.showProductModal = true
    },
    remove(id) {
      this.removeRow(this.$api.product.remove, 'Id', id)
    },
  },
}
</script>
